var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/58e4aaf512c3bbd09fa3e63b26a8ae7d.js').default;export default
        Object.assign({}, scope_0 )
    